import React from 'react';
import { observer } from 'mobx-react';

import { Box, styled } from '@mui/material';
import {} from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const ReplacementHistoryTab = () => {
  const { t } = useTranslation();

  return (
    <StyledRootBox>
      <Box className="tab_content">{t('SystemConfiguration.replacementHistory')}</Box>
    </StyledRootBox>
  );
};

export default observer(ReplacementHistoryTab);

const StyledRootBox = styled(Box)(({ theme: { palette } }) => ({
  padding: '16px',
  backgroundColor: palette.background.main,
}));
